import Vue from 'vue';

Vue.component('operational-dashboard-index', () =>
    import(/* webpackChunkName: 'operational-dashboard-index' */ './operational-dashboard-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/dashboard/operational-dashboard/index.js